import React, { useState, useEffect } from 'react';
import ActionComponent from './ActionComponent';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import DynamicSearchBar from './../../components/common/SearchBar';
import OverlayComponent from './OverlayComponent';
import SearchableDropdownComponent from '../../components/common/SearchableDropDown';
import DataTable from '../../components/common/CommonDataTable';
import OverlayCard from '../../components/common/OverlayCard';
import Button from './../../components/common/Button';
import PlusSvgIcon from './../../assets/svg_main/plus.svg';
import SettingIcon from './../../assets/svg_main/settings.svg';
import CrossIcon from '../../assets/svg_main/CrossIconBlack.svg';
import endpoints from '../../config/endpoints';
import './UserManagement.css';
import { getData } from '../../services/CommonApiService';
import Auth from "../../utils/auth";
import { errorLogger } from '@utils/applicationLogUtils';

interface objectType {
    [key: string]: any;
}

let data: any[] = [];

//setting initial checkbox value to true
let filterCheckBox: objectType = {};
let dropdowndata: objectType = {};

const style = {
    singleValue: (baseStyles: any) => ({
        ...baseStyles,
        fontSize: '12px',
        color: '#797979',
        textAlign: 'center',
        padding: '5px 10px',
    }),
    option: (baseStyles: any, state: any) => ({
        ...baseStyles,
        fontSize: '12px',
        color: state.isFocussed ? '#FFF' : '#797979',
        '&:hover': {
            color: '#FFF',
        },
    }),
    menu: (style: any) => ({
        ...style,
        maxHeight: 250,
    }),
    menuList: (style: any) => ({
        ...style,
        maxHeight: 250,
        overFlowY: 'auto',
    }),
    placeholder: (base: any, state: any) => ({
        ...base,
        marginTop: 5,
        marginLeft: 5,
        color: 'rgba(179, 179, 179, 1)',
        fontWeight: 400,
        fontSize: 12,
        display: state.isFocused && 'none',
    }),
    multiValue: (base: any, state: any) => ({
        ...base,
        minWidth: '55px',
    }),
    valueContainer: () => ({
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'overlay',
        marginLeft: 5,
        fontSize: 12,
    }),
};

const constructActionData = (dataList: any) => {
    return dataList.map((data: any) => {
        return {
            ...data,
            Action: {
                type: 'component',
                component: ActionComponent,
            },
            status: data.status ? "Enabled" : "Disabled",
            description: data.description
        };
    }).reverse();
};
const RoleManagement = () => {
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [gridData, setGridData] = useState<any[]>([]);
    const [eventKeyval, seteventKeyval] = useState<any[]>([]);
    const [checkboxValue, setCheckboxValue] = useState<any>({});
    const [show, setShow] = useState(false);
    const [dropDownFilterList, setDropDownFilterList] = useState<any>({});
    const handleSearchChange = _.debounce((value: string) => {
        setSearchTerm(value);
    }, 1000);
    const navigate = useNavigate();
    const columnHeader = [
        {
            name: 'User Type',
            key: 'user_type',
            sortable: true,
            filterRequired: true,
            filterDefault: false,
            width: 180,
            disabled: true
        },
        {
            name: 'User Role',
            key: 'role_name',
            sortable: true,
            filterRequired: true,
            filterDefault: true,
            showDetails: 'role_name',
            width: 180,
            disabled: true
        },
        {
            name: 'User Designation',
            key: 'user_designation',
            sortable: true,
            filterRequired: true,
            filterDefault: true,
            width: 180,
            disabled: true
        },
        {
            name: 'Status',
            key: 'status',
            sortable: true,
            filterRequired: true,
            filterDefault: true,
            width: 180,
        },
        {
            name: 'Action',
            key: 'Action',
            sortable: false,
            filterRequired: false,
            filterDefault: false,
            width: 180,
        },
    ];
    const filteredColumnheader = columnHeader.filter((obj) => {
        return checkboxValue[obj.key] || obj.key === "Action";
    });
    
    const dropDownKeys = _.filter(
        columnHeader,
        (filterList) => filterList.filterRequired,
    );

    const formatData = async (res: any) => {
        dropDownKeys.forEach((item, idx) => {

            const option = _.map(_.uniq(_.map(res.data, item.key)), (i) => {
                if (i) {
                    return { value: i, label: i };
                }
            });
            const options = option.filter((item: any) => item !== undefined);

            dropdowndata = {
                ...dropdowndata,
                [item.key]: options,
            };
            filterCheckBox = {
                ...filterCheckBox,
                [item.key]: idx < 3,
            };
        });
        const modifiedData = constructActionData(res.data);
        data = modifiedData;
        const filterlistfromSession = sessionStorage.getItem('roleFilter');
        const parseToObject = filterlistfromSession ? JSON.parse(filterlistfromSession) : null;
        parseToObject ? setCheckboxValue({ ...parseToObject }) : setCheckboxValue({ ...filterCheckBox });
        setGridData(modifiedData.reverse());
    }

    const initialFetch = async () => {
       try {
        const rolesData = await getData<any[]>(`${endpoints.getAllRolesList}`);
        formatData(rolesData);
       }    catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }

    useEffect(() => {
        if (searchTerm.length === 0) {
            initialFetch();
        }
        else if (searchTerm.length >= 3) {
            filterFetch();
        }
    }, [searchTerm])

    const filterFetch = async () => {
        try {
            const searchResponse = await getData<any[]>(`${endpoints.getSearchRole + '/' + searchTerm}`)
            formatData(searchResponse);
        }    catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
          }
    }

    useEffect(() => {
        const list = getDropDownOptions(gridData);
        setDropDownFilterList({ ...list });
    }, [gridData]);


    const filterLoop = (dataList: any[], key: string, keyFilter: string[]) => {
        const tempData: any[] = [];
        dataList.forEach((dataValue: any) => {
            const isFilter = keyFilter.find((val) => val === dataValue[key])
            if (isFilter) {
                tempData.push(dataValue);
            }
        });
        return tempData;
    };

    const applyFilter = (eventKey: any, index: number, eValue: any) => {
        const updatedValues = [...eventKeyval];
        updatedValues[index] = eventKey;
        seteventKeyval(updatedValues);
        let tempData: any = [...data];
        const keyNames = Object.keys(filterCheckBox);
        updatedValues.forEach((keyFilter: any, i: number) => {
            const key = keyNames[i];
            if (keyFilter && keyFilter.length >= 1) {
                tempData = filterLoop(tempData, key, keyFilter);
            }
        });
        setGridData(tempData);
    };

    const clearFilter = () => {
        seteventKeyval([]);
        setGridData(data);
    };

    const onChangeCheckbox = (list: any) => {
        setCheckboxValue({ ...list });
        sessionStorage.setItem("roleFilter", JSON.stringify({ ...list }));
        setShow(false);
    };

    const getDropDownOptions = (data: any) => {
        let dropdowndataValue = {};
        dropDownKeys.forEach((item, idx) => {
            const itemMap = _.map(data, (itemKey) => {
                if (itemKey[item.key] && itemKey[item.key].type == 'component') {
                    return itemKey[item.key].value
                } else {
                    return itemKey[item.key]
                }
            });
            const uniquList = _.uniq(itemMap);

            const option = _.map(uniquList, (i) => {
                if (i) {
                    if (i.type == 'component') {
                        return { value: i.value, label: i.value };
                    } else {
                        return { value: i, label: i };
                    }
                }
            });
            const options = option.filter((item: any) => item !== undefined);

            dropdowndataValue = {
                ...dropdowndataValue,
                [item.key]: options,
            };
        });
        return dropdowndataValue;
    }

    const renderFilter = () => {
        return dropDownKeys.map((dropdata, index) => {
            const selectedDropdownValue =
                eventKeyval[index] &&
                eventKeyval[index].map((key: string) => ({
                    value: key,
                    label: key,
                }));
            if (!checkboxValue[dropdata.key]) return;
            return (
                <>
                    <SearchableDropdownComponent
                        // options={dropdowndata[dropdata.key]}
                        options={dropDownFilterList[dropdata.key]}
                        placeHolder={dropdata.name}
                        multipleSelection={true}
                        onChange={(value) => applyFilter(value, index, dropdata.key)}
                        dropDownType="entered"
                        dropLabelName={dropdata.name}
                        dropDownDisable={false}
                        ifRequired={false}
                        dropdownsearchable={true}
                        isClearable={false}
                        className={'user-filter-dropdown'}
                        style={style}
                        value={selectedDropdownValue ? selectedDropdownValue : null}
                    />
                </>
            );
        });
    }

    const addNewRole = () => {
        navigate(`/user-management/create-new-role`);
    };

    return (
        <div className="user-management-details">
            <div className="search-add-user">
                <DynamicSearchBar
                    onChange={handleSearchChange}
                    placeHolder={'Search by Role, User Type, User Designation'}
                    disabled={false}
                    className="user-search"
                    iconNeeded={true}
                />
                <Button
                    onClick={addNewRole}
                    disabled={false}
                    id="add-user"
                    buttonName={'Create a new Role'}
                    colorType={'primary'}
                    icon={<PlusSvgIcon />}
                    iconPosition={'left'}
                />
            </div>
            <div className="user-filter">
                <div className="user-filter-label-icon">
                    <h6 className="user-filter-label">FILTERS</h6>

                    <div className='download_symbol_css'>
                        <OverlayCard
                            show={show}
                            setShow={setShow}
                            triggerComponent={show ? <CrossIcon className="user-cross-icon" /> : <SettingIcon className="user-setting-icon" />}
                            trigger="click"
                            overlayComponent={OverlayComponent(
                                dropDownKeys,
                                onChangeCheckbox,
                                checkboxValue,
                            )}
                            placement="bottom-end"
                        />
                    </div>
                </div>

                <div className="filter">
                    {dropDownKeys && dropDownFilterList && renderFilter()}
                    {eventKeyval?.some((filter) => filter?.length > 0) &&
                        (
                            <Button
                                onClick={clearFilter}
                                disabled={false}
                                id="user-filter-clear"
                                buttonName={'Clear Filter'}
                                colorType={'save'}
                                icon={''}
                                iconPosition={''}
                            />
                        )}
                </div>
            </div>
            <div className="user-table">
                <DataTable
                    data={filteredColumnheader.length > 1 ? gridData : []}
                    itemsPerPage={[10, 20, 30, 40, 50]}
                    pagination={gridData.length > 10}
                    height={'300px'}
                    searchTerm={searchTerm}
                    columnHeader={filteredColumnheader}
                    gridFor={'role'}
                />
            </div>
        </div>
    )
}

export default RoleManagement